









































































import Vue from 'vue';
import {
  Component, Inject, Provide, Watch, Prop,
} from 'vue-property-decorator';
import moment from 'moment';
import { mapState } from 'vuex';
import {
  KCardHeader, KCardHeaderBtn,
} from '@kasasa/fbase-components';
import {
  Alert, NoticeClass, AuthStore, Dialog,
} from '@kasasa/fbase-components/lib';
import { Cycle, CycleResource } from '@/api/cycles';
import { ReloadJob, ReloadResource } from '@/api/reload/index';
import { Product, ProductResource } from '@/api/product/index';
import RecompTotalSummaryCard from '@/components/recomp/RecompTotalSummaryCard.vue';
import RecompCycleProductAccountSummaryCard from '@/components/recomp/RecompCycleProductAccountSummaryCard.vue';
import { RecompCycleProductSummary, RecompCycleProductAccountSummary, RecompResource } from '@/api/recomp';
import { RecompSummaryReportExists } from '@/api/recomp/RecompSummaryReportExists';

@Component({
  computed: mapState([
    'fiId',
  ]),
  components: {
    KCardHeader,
    KCardHeaderBtn,
    RecompTotalSummaryCard,
    RecompCycleProductAccountSummaryCard,
  },
})
export default class RecompSummary extends Vue {
  headerItems: any = [{
    text: 'Rewards Processing',
    disabled: false,
    link: false,
  },
  {
    text: 'Recomp Summary',
    disabled: true,
  }];

  @Prop() reloadId!: string;

  fiId!: number

  reloadJob!: ReloadJob;

  recompCycles: Array<Cycle> = [];

  fiProducts: Array<Product> = [];

  externalProductMappingIdsInRecomp: Array<number> = [];

  recompCycleProductSummaries: Array<RecompCycleProductSummary> = [];

  recompCycleProductAccountSummariesMap!: Map<number, Array<RecompCycleProductAccountSummary>>;

  recompCycleProductSummariesMap!: Map<number, Array<RecompCycleProductSummary>>;

  reloadJobNotFound: boolean = false;

  @Inject('ReloadResource')
  private reloadResource!: ReloadResource;

  @Inject('CycleResource')
  private cycleResource!: CycleResource;

  @Inject('ProductResource')
  private productResource!: ProductResource

  @Inject('RecompResource')
  private recompResource!: RecompResource

  mounted() {
    this.loadData();
  }

  async loadData() {
    await this.loadReloadJob();

    await this.loadFiProducts();

    await this.loadCycles();

    await this.getRecompCycleProductSummaries();

    await this.getRecompCycleProductAccountSummaries();
  }

  async loadReloadJob() {
    if (this.reloadId) {
      await this.reloadResource.getReloadById(this.reloadId)
        .then((fetchedReloadJob: ReloadJob) => {
          this.reloadJob = fetchedReloadJob;
        }).catch((error: any) => {
          this.reloadJobNotFound = true;
          this.showErrorMessage(`Could not load Reload with ID [${this.reloadId}].`);
        });
    }
  }

  async loadFiProducts() {
    if (this.fiId) {
      await this.productResource.getAllProducts(this.fiId.toString())
        .then((returnedFiProducts: Product[]) => {
          this.fiProducts = returnedFiProducts;
        }).catch((error: any) => {
          this.showErrorMessage(error);
        });
    }
  }

  async loadCycles() {
    if (this.reloadJob && this.reloadJob.fiId) {
      this.cycleResource.getAllCycles(this.reloadJob.fiId.toString())
        .then((allCycles: Cycle[]) => {
          // sort cycles by qual start date
          const allSortedCycles = allCycles.sort((a, b) => RecompSummary.compareCyclesForSort(a, b));
          this.recompCycles = allSortedCycles.filter(
            (currentCycle: Cycle) => this.isCycleInRecompArgs(currentCycle),
          );
        }).catch((error: any) => {
          this.showErrorMessage(error);
        });
    }
  }

  async getRecompCycleProductSummaries() {
    if (this.reloadId) {
      await this.recompResource.getRecompCycleProductSummaries(this.fiId, this.reloadId)
        .then((results: RecompCycleProductSummary[]) => {
          this.recompCycleProductSummariesMap = new Map();
          results.forEach((summary: RecompCycleProductSummary) => {
            const currentProducts = this.fiProducts.filter((product: Product) => product.productMapping && product.productMapping.externalProductMappingId === summary.externalProductMappingId);
            if (currentProducts.length > 0) {
              summary.productName = currentProducts[0].productMapping.fiProductName; // eslint-disable-line no-param-reassign
              const externalProductMappingId: number = currentProducts[0].productMapping.externalProductMappingId || 0;
              if (!this.recompCycleProductSummariesMap.has(externalProductMappingId)) {
                this.recompCycleProductSummariesMap.set(externalProductMappingId, []);
              }
              this.recompCycleProductSummariesMap.get(externalProductMappingId)!.push(summary);
            } else {
              summary.productName = 'Product Name not found'; // eslint-disable-line no-param-reassign
            }
          });
          this.recompCycleProductSummaries = results;
        }).catch((error: any) => {
          this.showErrorMessage(error);
        });
    }
  }

  async getRecompCycleProductAccountSummaries() {
    if (this.reloadId) {
      await this.recompResource.getRecompCycleProductAccountSummaries(this.fiId, this.reloadId)
        .then((results: RecompCycleProductAccountSummary[]) => {
          this.recompCycleProductAccountSummariesMap = new Map();
          results.forEach((recompSummary: RecompCycleProductAccountSummary) => {
            const currentProducts = this.fiProducts.filter((product: Product) => product.productMapping && product.productMapping.externalProductMappingId === recompSummary.externalProductMappingId);
            if (currentProducts.length > 0) {
              const externalProductMappingId: number = currentProducts[0].productMapping.externalProductMappingId || 0;
              if (!this.recompCycleProductAccountSummariesMap.has(externalProductMappingId)) {
                this.recompCycleProductAccountSummariesMap.set(externalProductMappingId, []);
              }
              this.recompCycleProductAccountSummariesMap.get(externalProductMappingId)!.push(recompSummary);
            }
            recompSummary.qualificationsEndDate = this.getQualEndDateForCycle(recompSummary.cycleId); // eslint-disable-line no-param-reassign
          });
          this.externalProductMappingIdsInRecomp = [];
          this.recompCycleProductAccountSummariesMap.forEach((value: RecompCycleProductAccountSummary[], key: number) => {
            this.externalProductMappingIdsInRecomp.push(key);
          });
        }).catch((error: any) => {
          this.showErrorMessage(error);
        });
    }
  }

  getQualEndDateForCycle(cycleId: number) {
    const foundCycle = this.recompCycles.filter((cycle: Cycle) => cycle.id === cycleId);
    if (foundCycle.length > 0) {
      return foundCycle[0].qualificationEndDate.toString();
    }
    return '-not found-'; // should not happen
  }

  isCycleInRecompArgs(cycle: Cycle): boolean {
    const foundCycle = this.reloadJob.recompArgumentList.find(args => args.cycleId === cycle.id);
    return foundCycle !== undefined;
  }

  getProductNameForExternalMappingId(externalProductMappingId: number): string {
    const currentProducts = this.fiProducts.filter((product: Product) => product.productMapping && product.productMapping.externalProductMappingId === externalProductMappingId);
    // we should not have a summary for an external product mapping id that is not in fiProducts.
    return currentProducts[0].productMapping.fiProductName;
  }

  static compareCyclesForSort(a: Cycle, b: Cycle): number {
    return a.qualificationStartDate < b.qualificationStartDate ? -1 : 1;
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  downloadReport() {
    if (this.fiId) {
      this.recompResource.doesRecompSummaryReportExists(this.fiId, this.reloadId)
        .then((result: RecompSummaryReportExists) => {
          if (!result || !result.reportExists) {
            const dialog = new Dialog('No file found on s3.', 'This likely means no differences were found.');
            this.$store.dispatch('notices/add', dialog);
          } else {
            this.recompResource.downloadReportAsBlob(this.fiId, this.reloadId, result.s3FileKey!)
              .then((reportContent: Blob) => {
                RecompSummary.downloadReportContent(reportContent, RecompSummary.filenameFromS3FileKey(result.s3FileKey!));
              }).catch((error) => { this.showErrorMessage(error); });
          }
        }).catch((error: any) => {
          this.showErrorMessage('Could not validate if summary file exists');
        });
    }
  }

  private static downloadReportContent(content: Blob, filename: string) {
    const anchor = document.createElement('a');
    anchor.href = URL.createObjectURL(content);
    anchor.download = filename;
    anchor.id = 'file-download-link';
    anchor.click();
  }

  private static filenameFromS3FileKey(s3FileKey: string) {
    const tmp = s3FileKey.replace(/\//g, '_');
    return tmp.substring(tmp.indexOf('_'));
  }
}
